import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from './baseQuery';

export interface PhoneCountryCode {
  region: string;
  dial_code: string;
  name: string;
}

export const phoneCodeApi = createApi({
  reducerPath: 'phoneCodeApi',
  baseQuery: createExtendedTokenBaseQuery(''),
  tagTypes: ['PhoneCode'],
  endpoints: (builder) => ({
    getPhoneCountryCodes: builder.query<PhoneCountryCode[], void>({
      query: () => ({
        url: 'phone/country-codes/',
        method: 'GET',
      }),
      providesTags: ['PhoneCode'],
    }),
  }),
});

export const { useGetPhoneCountryCodesQuery } = phoneCodeApi;
